import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { CartProvider } from "./Component/CartContext";
import ErrorBoundary from "./Component/ErrorBoundary";
import Footer from "./Component/Footer";
import Header from "./Component/Header";
import NotFound from "./Component/NotFound";
import ScrollToTop from "./Component/ScrollToTop";

const Main = lazy(() => import("./Component/Main"));
const Shop = lazy(() => import("./Component/Shop"));
const ProductDetail = lazy(() => import("./Component/ProductDetail"));
const CartPage = lazy(() => import("./Component/CartPage"));
const CheckOut = lazy(() => import("./Component/CheckOut"));
const PaySuccess = lazy(() => import("./Component/SuccessPay"));
const About = lazy(() => import("./Component/About"));
const Contact = lazy(() => import("./Component/Contact"));
const Privacy = lazy(() => import("./Component/Privacy"));
const Terms = lazy(() => import("./Component/Terms"));
const Returns = lazy(() => import("./Component/Returns"));
const Delivery = lazy(() => import("./Component/Delivery"));
const FAQs = lazy(() => import("./Component/FAQs"));
const Cookies = lazy(() => import("./Component/Cookies"));

const PageLoader = () => (
  <div className="page-loader" role="status" aria-live="polite">
    <span />
    <p>Preparing something delicious…</p>
  </div>
);

const App = () => (
  <CartProvider>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <ScrollToTop />
      <Header />
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:category" element={<Shop />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/cartpage" element={<Navigate to="/cart" replace />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/order-success" element={<PaySuccess />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/payment" element={<PaySuccess />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
      <Footer />
    </BrowserRouter>
  </CartProvider>
);

export default App;
